import React from "react";
import GenericCardListSkeleton from "@packages/common/src/components/skeletons/GenericCardListSkeleton";

const AppsListSkeleton = () => {
  return (
    <GenericCardListSkeleton
      items={4}
      gridProps={{ rowGap: 6 }}
      gridItemProps={{ xl: 3 }}
      boxProps={{
        width: 309,
        height: 170,
        sx: {
          "& .MuiSkeleton-root": {
            borderRadius: 2.5,
          },
        },
      }}
    />
  );
};

export default AppsListSkeleton;
